<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Work Experience Companies</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onWorkExperienceCompanyCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" [disabled]="isExporting" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
      <button mat-raised-button color="primary" (click)="onCreateWorkExperienceCompany()">
        <mat-icon>add</mat-icon>
        Add Work Experience Company
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    [countries]="countries"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="workExperienceCompanies()"
      [columns]="workExperienceCompaniesColumns"
      [enablePaging]="true"
      [enableMatching]="true"
      [serverSidePagination]="true"
      [totalCount]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      initialSortColumn="name"
      initialSortDirection="asc"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditWorkExperienceCompany($event)"
      (deleteClick)="onDeleteWorkExperienceCompany($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (pageChange)="onPageChange($event)"
      (sortChange)="onSortChange($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
